"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledButton = styled_components_1.default.button `
  align-items: center;
  background: ${config_1.colors.white};
  border: 1px solid ${config_1.colors.huron};
  border-radius: ${({ radius }) => (radius ? radius : '8px')};
  display: flex;
  height: 45px;
  width: 175px;

  &:hover,
  &:focus {
    background: ${config_1.colors.white};
    border-color: ${config_1.colors.blurple};
    box-shadow: none;
  }
`;
